import Select from "react-select";
import "./LayerEditSection.scss";
import FormField from "../../../FormField/FormField";
import { attributeSelectOption } from "../../../../constants/acronyms";

const DEFAULT_RULE_COLOR = "#4d504f";

const LayerEditSection = ({
  selectedComune,
  chiave,
  tipo,
  color,
  selectedCrs,
  handleCrsChange,
  handleInputChange,
  colorByAttribute,
  onColorByAttributeChange,
  attributeOptions = [],
  isLoadingAttributes = false,
}) => {
  const crsArray = ["EPSG:4326", "EPSG:32632", "EPSG:32633", "EPSG:3857"];

  const attribute = colorByAttribute?.attribute ?? "";
  const rules = Array.isArray(colorByAttribute?.rules)
    ? colorByAttribute.rules
    : [];

  const selectedAttributeOption = attribute
    ? attributeOptions.find((opt) => opt.value === attribute) ??
      attributeSelectOption(attribute)
    : null;

  const setAttribute = (value) => {
    onColorByAttributeChange((prev) => ({
      ...prev,
      attribute: value,
    }));
  };

  const setRules = (nextRules) => {
    onColorByAttributeChange((prev) => ({
      ...prev,
      rules: typeof nextRules === "function" ? nextRules(prev.rules) : nextRules,
    }));
  };

  const updateRule = (index, patch) => {
    setRules((prev) =>
      prev.map((row, i) => (i === index ? { ...row, ...patch } : row))
    );
  };

  const removeRule = (index) => {
    setRules((prev) => prev.filter((_, i) => i !== index));
  };

  const addRule = () => {
    setRules((prev) => [...prev, { value: "", color: DEFAULT_RULE_COLOR }]);
  };

  return (
    <div className="layer-match-container">
      <div className="comune-wrapper">
        <p>Comune/Parco: </p>
        <p>{selectedComune?.nome}</p>
      </div>

      <div className="chiave-wrapper">
        <label htmlFor="chiave">Chiave di associazione GIS </label>
        <input
          type="text"
          name="chiave"
          value={chiave}
          onChange={handleInputChange}
        />
      </div>

      <div className="crs-wrapper">
        <p>CRS: </p>
        <div>
          <Select
            options={crsArray.map((crs) => ({ value: crs, label: crs }))}
            value={selectedCrs}
            onChange={handleCrsChange}
          />
        </div>
      </div>

      <div className="tipo-wrapper">
        <label htmlFor="tipo">Tipo: </label>
        <input
          type="text"
          name="tipo"
          value={tipo}
          onChange={handleInputChange}
        />
      </div>

      <FormField
        fieldStructure={{
          label: "Colore di base",
          type: "color",
          editable: true,
        }}
        value={color}
        onChange={(newValue) =>
          handleInputChange({
            target: { name: "color", value: newValue },
          })
        }
        disabled={false}
      />

      <section className="layer-attribute-colors-section">
        <h2 className="layer-attribute-colors-title">
          Colori in base a un attributo
        </h2>
        <p className="layer-attribute-colors-help">
          Scegli una proprietà del layer e associa un colore a ciascun valore. I
          dati vengono inviati al server con il salvataggio del layer (
          <code>colors</code>).
        </p>

        <div className="layer-attribute-colors-field">
          <label htmlFor="style-attribute-key">Attributo (chiave proprietà)</label>
          <Select
            inputId="style-attribute-key"
            className="layer-attribute-colors-select"
            classNamePrefix="layer-attribute-colors-select"
            options={attributeOptions}
            value={selectedAttributeOption}
            onChange={(option) => setAttribute(option?.value ?? "")}
            isLoading={isLoadingAttributes}
            isDisabled={isLoadingAttributes || attributeOptions.length === 0}
            isClearable
            placeholder={
              isLoadingAttributes
                ? "Caricamento proprietà..."
                : attributeOptions.length === 0
                  ? "Nessuna proprietà disponibile"
                  : "Seleziona attributo (es. anno)"
            }
          />
        </div>

        {attribute.trim() ? (
          <div className="layer-attribute-colors-rules-panel">
            <div className="layer-attribute-colors-table-head">
              <span>Valore dell&apos;attributo</span>
              <span>Colore</span>
              <span aria-hidden="true" />
            </div>
            <div className="layer-attribute-colors-rules-scroll">
              <ul className="layer-attribute-colors-rules">
                {rules.map((rule, index) => (
                  <li key={index} className="layer-attribute-colors-row">
                    <input
                      type="text"
                      placeholder="es. 2020"
                      value={rule.value ?? ""}
                      onChange={(e) =>
                        updateRule(index, { value: e.target.value })
                      }
                      aria-label={`Valore regola ${index + 1}`}
                    />
                    <input
                      type="color"
                      value={rule.color || DEFAULT_RULE_COLOR}
                      onChange={(e) =>
                        updateRule(index, { color: e.target.value })
                      }
                      aria-label={`Colore regola ${index + 1}`}
                    />
                    <button
                      type="button"
                      className="layer-attribute-colors-remove"
                      onClick={() => removeRule(index)}
                    >
                      Rimuovi
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <button
              type="button"
              className="layer-attribute-colors-add"
              onClick={addRule}
            >
              Aggiungi valore
            </button>
          </div>
        ) : (
          <p className="layer-attribute-colors-muted">
            Seleziona un attributo per aggiungere regole colore.
          </p>
        )}
      </section>
    </div>
  );
};

export default LayerEditSection;
